import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { PublicService } from "../../services/api/public.service";
import { PublicActions } from "../actions/public.actions";
import { FailState } from "../models/fail-state";
@Injectable()
export class PublicEffects {
	countries = createEffect(() =>
		this.actions.pipe(
			ofType(PublicActions.countries.get),
			switchMap(() =>
				this.publicService.countries().pipe(
					map(() => PublicActions.countries.getSuccess()),
					catchError((error) => of(PublicActions.countries.getFail(new FailState(error))))
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private publicService: PublicService
	) {}
}
